import { isRecord } from '~/components/Guardrails/types';

import TEXTS from './texts';

/** What the System of Record did with an action the organization commits there, as the server's `error_code`. */
export type SorErrorCode = keyof typeof TEXTS.errorTitles;

const isSorErrorCode = (value: unknown): value is SorErrorCode =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(TEXTS.errorTitles, value);

/** The SoR outcome a failed request was answered with, or null for any other failure. */
export const getSorErrorCode = (error: unknown): SorErrorCode | null => {
  const response = isRecord(error) ? error.response : undefined;
  const errorCode = isRecord(response) && isRecord(response.data) ? response.data.error_code : undefined;
  return isSorErrorCode(errorCode) ? errorCode : null;
};

export const getSorErrorTitle = (errorCode: SorErrorCode): string => TEXTS.errorTitles[errorCode];

/** Whether a request failed because its own timeout expired before the server answered. */
export const isRequestTimeout = (error: unknown): error is { code: 'ECONNABORTED' } =>
  isRecord(error) && error.code === 'ECONNABORTED';

/**
 * Failures the SoR interceptor already explained to the user in its own dialog, so the caller's own error report
 * does not show a second, generic popup for them. A WeakSet, like the guardrails one.
 */
const handledErrors = new WeakSet<object>();

export const markSorHandled = (error: object): void => {
  handledErrors.add(error);
};

export const isSorHandledError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && handledErrors.has(error);
